export default __webpack_public_path__ + "static/media/lock-icon.2c86ed54.svg";